import { AuthContextType } from '@auth/AuthProvider';
import NetworkController, { HTTPMethod, HTTPRequest, HTTPResponse } from '@data/controller/NetworkController';
import Playlist from '@data/interfaces/playlist.interface';
import { SongAttributes } from '@data/interfaces/song.interface';

export default class PlaylistsController {
  private static baseURL: string = process.env.REACT_APP_SANCTUARY_API_URL || "";

  static async fetchPlaylists(churchID: string, auth: AuthContextType): Promise<HTTPResponse<Playlist[]>> {
    return await NetworkController.performRequestAt<Playlist[]>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.GET, `/v1/church/${churchID}/library/playlist`),
      auth.consumeRefreshToken
    );
  }

  static async fetchPlaylist(churchID: string, playlistID: string, auth: AuthContextType): Promise<HTTPResponse<Playlist>> {
    return await NetworkController.performRequestAt<Playlist>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.GET, `/v1/church/${churchID}/library/playlist/${playlistID}`),
      auth.consumeRefreshToken
    );
  }

  static async createPlaylist(
    churchID: string,
    attributes: Playlist.Attributes,
    auth: AuthContextType
  ): Promise<HTTPResponse<Playlist>> {
    return await NetworkController.performRequestAt<Playlist>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.POST, `/v1/church/${churchID}/library/playlist`, {
        attributes
      }),
      auth.consumeRefreshToken
    );
  }

  static async addSongToPlaylist(
    churchID: string,
    playlistID: string,
    songAttributes: SongAttributes,
    auth: AuthContextType
  ): Promise<HTTPResponse<{ result: Playlist }>> {
    return await NetworkController.performRequestAt<{ result: Playlist }>(
      this.baseURL,
      new HTTPRequest(
        HTTPMethod.POST, 
        `/v1/church/${churchID}/library/playlist/${playlistID}/songs`,
        songAttributes
      ),
      auth.consumeRefreshToken
    );
  }

  static async removeSongFromPlaylist(
    churchID: string,
    playlistID: string,
    songID: string,
    auth: AuthContextType
  ): Promise<HTTPResponse<void>> {
    return await NetworkController.performRequestAt<void>(
      this.baseURL,
      new HTTPRequest(
        HTTPMethod.DELETE,
        `/v1/church/${churchID}/library/playlist/${playlistID}/songs/${songID}`
      ),
      auth.consumeRefreshToken
    );
  }
}
